import axios from "axios";

export const state = {
    staff: [],
    delivery_staff: [],
    positions: [],
    payroll:[],
    salary_advances:[],
    staff_allowances:[],
    staff_salaries:[],
    monthly_staff_salaries:[],
    save_status: false,
};
export const getters = {
    Staff: state => state.staff.data,
    DeliveryStaff: state => state.delivery_staff.data,
    StaffPositions: state => state.positions.data,
    StaffPayroll: state => state.payroll.data,
    StaffAdvances: state => state.salary_advances.data,
    StaffAllowances: state => state.staff_allowances.data,
    StaffSalaries: state => state.staff_salaries.data,
    MonthlyStaffSalaries: state => state.monthly_staff_salaries,
    StaffSave: state => state.save_status,
};
export const mutations = {
    SET_STAFF(state, newValue) {
        state.staff = newValue
    },

    SET_DELIVERY_STAFF(state, newValue) {
        state.delivery_staff = newValue
    },

    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },

    SET_STAFF_POSITION(state, newValue) {
        state.positions = newValue
    },

    SET_STAFF_PAYROLL(state, newValue) {
        state.payroll = newValue
    },

    SET_STAFF_ADVANCES(state, newValue) {
        state.salary_advances = newValue
    },

    SET_STAFF_ALLOWANCES(state, newValue) {
        state.staff_allowances = newValue
    },

    SET_STAFF_SALARIES(state, newValue) {
        state.staff_salaries = newValue
    },

    SET_MONTHLY_STAFF_SALARIES(state, newValue) {
        state.monthly_staff_salaries = newValue
    },
};
export const actions = {
    addStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff', payload).then(() => {
            dispatch('fetchAllStaff');
            dispatch('fetchStaff');
            let message = { 'msg': ` Staff added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff " }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff/${payload.id}`).then(() => {
            dispatch('fetchStaff');
            let message = { 'msg': `Staff  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Staff
    editStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff/${payload.id}`, payload).then(() => {
            dispatch('fetchStaff');
            let message = { 'msg': `Details of Staff ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Staff
    fetchStaff({ commit }) {
        axios.get('staff').then(ec_res => {
            commit('SET_DELIVERY_STAFF', ec_res.data)
        })
    },

    fetchAllStaff({ commit }) {
        axios.get('all_staff').then(ec_res => {
            commit('SET_STAFF', ec_res.data)
        })
    },

    addStaffPosition({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_position', payload).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': ` Staff position added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff " }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteStaffPosition({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_position/${payload.id}`).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': `Staff position record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    
    // Edit Staff
    editStaffPosition({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_position/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': `Details of Staff position ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff position Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Fetch Staff

    fetchStaffPositions({ commit }) {
        axios.get('staff_position').then(ec_res => {
            commit('SET_STAFF_POSITION', ec_res.data)
        })
    },

    // Staff Payroll
    addStaffPayroll({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_payroll', payload).then(() => {
            dispatch('fetchStaffPayroll');
            let message = { 'msg': ` Staff enrolled to payroll successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff Payroll" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Payroll
    deleteStaffPayroll({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_payroll/${payload.id}`).then(() => {
            dispatch('fetchStaffPayroll');
            let message = { 'msg': `Staff payroll record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Payroll
    editStaffPayroll({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_payroll/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffPayroll');
            let message = { 'msg': `Details of Staff payroll ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff payroll Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Payroll
    fetchStaffPayroll({ commit }) {
        axios.get('staff_payroll').then(ec_res => {
            commit('SET_STAFF_PAYROLL', ec_res.data)
        })
    },


    // Staff advances
    addStaffAdvance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('salary_advances', payload).then(() => {
            dispatch('fetchStaffAdvances');
            let message = { 'msg': `Staff advance added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff advance" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Advance
    deleteStaffAdvance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`salary_advances/${payload.id}`).then(() => {
            dispatch('fetchStaffAdvances');
            let message = { 'msg': `Staff advance record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Advance
    editStaffAdvance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`salary_advances/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffAdvances');
            let message = { 'msg': `Details of Staff advance ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff advance Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Advances
    fetchStaffAdvances({ commit }) {
        axios.get('salary_advances').then(ec_res => {
            commit('SET_STAFF_ADVANCES', ec_res.data)
        })
    },


    // Staff allowances
    addStaffAllowance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_allowances', payload).then(() => {
            dispatch('fetchStaffAllowances');
            let message = { 'msg': `Staff allowance payment recorded successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Recording Staff allowance payment" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Allowance
    deleteStaffAllowance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_allowances/${payload.id}`).then(() => {
            dispatch('fetchStaffAllowances');
            let message = { 'msg': `Staff allowance record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Allowance
    editStaffAllowance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_allowances/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffAllowances');
            let message = { 'msg': `Details of Staff allowance for ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff allowance Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Allowances
    fetchStaffAllowances({ commit }) {
        axios.get('staff_allowances').then(ec_res => {
            commit('SET_STAFF_ALLOWANCES', ec_res.data)
        })
    },

    // Staff Salaries
    addStaffSalary({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_salaries', payload).then(() => {
            dispatch('fetchStaffSalaries');
            dispatch('fetchMonthlyStaffSalaries');
            let message = { 'msg': `Staff salary payment recorded successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Recording Staff salary payment" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Salary
    deleteStaffSalary({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_salaries/${payload.id}`).then(() => {
            dispatch('fetchStaffSalaries');
            let message = { 'msg': `Staff salary payment record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Salary
    editStaffSalary({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_salaries/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffSalaries');
            let message = { 'msg': `Details of Staff salary payment for ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff salary payment Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Salaries
    fetchStaffSalaries({ commit }) {
        axios.get('staff_salaries').then(ec_res => {
            commit('SET_STAFF_SALARIES', ec_res.data)
        })
    },

    // Fetch Monthly Staff Salaries
    fetchMonthlyStaffSalaries({ commit }) {
        axios.get('monthly_staff_salaries').then(ec_res => {
            commit('SET_MONTHLY_STAFF_SALARIES', ec_res.data)
        })
    },

};